export const isLoading = (state) => state.application.loading;
export const isMenuOpen = (state) => state.application.menuOpen;
export const showFooter = (state) => state.application.showFooter;
export const showMenuButton = (state) => state.application.showMenuButton;
